import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import { breakpoints, colors } from '../../constants';

/**
 * Custom IOS Button Wrapper to add bottom padding and overlay for button
 * making them appear above the ios tray bar and not hide them.
 * Adds an overlay at the bottom of the button and adds ios tray padding
 */
const IOSButtonWrapper = styled.div`
  width: 100%;
  padding: ${({ padding }) => padding ?? '0 16px 16px 16px'};
  ${({ fixedBreakpoint }) => css`
    @media (max-width: ${breakpoints[fixedBreakpoint]}) {
      position: fixed;
      bottom: 0;
      z-index: ${({ theme }) => theme.zIndexes[5]};
      margin-bottom: env(safe-area-inset-bottom);

      /*
       * Scrim behind the button so page content fades out underneath it rather
       * than meeting a hard edge. Drawn as a bottom-anchored pseudo-element so
       * it can extend past the wrapper's own box without affecting layout —
       * mirroring the design, where the 145px gradient layer sits behind an
       * 88px sticky bar (Figma node 32809:198861).
       */
      &::before {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        height: 145px;
        z-index: -1;
        pointer-events: none;
        background: linear-gradient(
          180deg,
          ${rgba(colors.newBackgroundSecondary, 0)} 40.18%,
          ${rgba(colors.newBackgroundSecondary, 0.8)} 88.57%
        );
      }
    }
  `};
`;

export { IOSButtonWrapper };
